import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import {actionSetUi} from '../data/action';
import {useDashboardQueryArgs} from './useQueryArgs'

// ----------------------------------------------------------------------
// loading states are set in actions and read in components
// ----------------------------------------------------------------------
export const useIsLoading = (part = "") =>{
	const [state, set] = useUiState({ key:`${part}IsLoading`, defaultValue: false})
	return [
		state === true,
		(value)=>{
			set(value === true)
		}
	]
}
export const useUiDashboardQueryIsLoading = () => useIsLoading("dashboard")
export const useUiTopContentIdsQueyIsLoading = () => useIsLoading("topContentIds")
export const useUiTopRefererQueyIsLoading = () => useIsLoading("topReferer")

// ----------------------------------------------------------------------
// form states
// ----------------------------------------------------------------------
export const useUiDashboardQuery = (defaultArgs)=>{
	const [queryArgs] = useDashboardQueryArgs(defaultArgs) // restore from last submitted query
	return useUiForm({key:"pageviewsQuery", args: queryArgs})
}

// --------------------------------------------------------
// safe form state
// --------------------------------------------------------
export const useUiForm = ({ key = "default", args})=>{
	return useUiState( {key: `form_${key}`, defaultValue: args})
}


// ----------------------------
// private functions
// ----------------------------
const useUiBool = ( {defaultValue = false, key = "bool"} ) => {
	const [value, setValue] = useUiState({defaultValue: defaultValue === true, key});
	return [value === true, _value => setValue(_value === true)];
};

const useUi = (selection = (ui) => ui)=> useSelector(({ui})=> selection(ui || {}));

const useUiState = ({key = "state", defaultValue = ""}) => {
	const dispatch = useDispatch();
	const value = useSelector(({ui})=> ui[key] || defaultValue);
	return [
		value,
		(_value)=>{
			dispatch(actionSetUi(key, _value));
		},
	];
};
